import axiosInstance from "./axiosInstance";

export async function revealMemberPii(memberId, field, section = null) {
  const response = await axiosInstance.post(
    `/households/members/${memberId}/reveal-pii`,
    section ? { section, field } : { field },
  );
  return response.data;
}

export async function revealAccountPii(accountId, section, field) {
  const response = await axiosInstance.post(
    `/households/accounts/${accountId}/reveal-pii`,
    { section, field },
  );
  return response.data;
}

export const REVEALABLE_PII_FIELDS = {
  personal_info: ["ssn_or_tin", "dob"],
  employment_info: ["tin"],
  trust_info: ["ssn_or_tin"],
  business_info: ["ssn"],
};
